import React from 'react';
import { Redirect } from 'react-router-dom';

// local dependencies
import { checkAppContext } from 'ui/hoc/checkAppContext';
import * as ROUTE_PATHS from 'constants/route-paths';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { temporaryLoginStage as TemporaryLoginStage } from 'ui/views/layouts/temporaryLoginStage';
 *
 * // render
 * <TemporaryLoginStage propName='propValue'/>
 */
const _temporaryLoginStage = () => {
	return (
		<Redirect to={ { pathname: ROUTE_PATHS.DASHBOARD } } />
	);
};

export const temporaryLoginStage = checkAppContext( _temporaryLoginStage );

// set display name
temporaryLoginStage.displayName = 'temporaryLoginStage';

// set default props
temporaryLoginStage.defaultProps = {};

// prop types
temporaryLoginStage.propTypes = {};
